import { render, staticRenderFns } from "./bottomFooter.vue?vue&type=template&id=090a6043&"
import script from "./bottomFooter.vue?vue&type=script&lang=js&"
export * from "./bottomFooter.vue?vue&type=script&lang=js&"
import style0 from "./bottomFooter.vue?vue&type=style&index=0&id=090a6043&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports